<template>
  <Dialog
    width="678px"
    :height="createRenderType == 'mobile' ? 'unset' : '350px'"
    titleAlign="left"
    :title="$$t('editor.edit_original_song')"
    :subTitle="
      $$tValue('editor.edit_original_song_subtitle', {
        minute: 1,
      })
    "
    :visible="renderData.visible"
    :customClass="`edit-origin_song-dialog ${
      createRenderType == 'mobile' ? 'edit-origin_song-dialog-mobile' : ''
    }`"
    @close="onClose"
    mobileRenderType="drawerDialog"
  >
    <div
      class="height-all edit-origin_song flex-column"
      :class="{
        'edit-origin_song-mobile': createRenderType == 'mobile',
      }"
      @click.stop
    >
      <!-- <div class="edit-origin_song-item-label">Clip song</div> -->
      <div class="edit-origin_song-item-clip">
        <SkyClippingFixedDuration
          :config="{
            spacingSize: 3,
            wavebarWidth: 1,
            clipDuration: 60,
            tbPadding: 10,
          }"
          v-if="renderData.ifRender"
          ref="refClipFixedDuration"
          :clipSourceData="renderData.clipSourceData"
          :label="$$t('create.select_clip')"
          :selectResultText="$$t('create.selected_clip_duration_result')"
        >
        </SkyClippingFixedDuration>
      </div>

      <div class="edit-origin_song-item-btn-box">
        <div class="edit-origin_song-item-btn">
          <Button
            @click="onDoneClick"
            :disabled="renderData.disableDoneBtn"
            :renderStyle="{
              '--padding': '0',
              '--width': '100%',
              '--height': '48px',
              '--borderRadius': '50px',
              '--fontColor': '#000',
              '--fontSize': '16px',
              '--fontWeight': 'normal',
              '--border': 'none',
              '--background':
                'linear-gradient(120deg, rgb(79, 222, 255, 1) -1%, rgb(230, 117, 255, 1) 100%)', //#94ADFF
              '--backgroundHover':
                'linear-gradient(120deg, rgb(79, 222, 255, 0.75) -1%, rgb(230, 117, 255, 0.75) 100%)',
              '--fontColorHover': '#000',
            }"
          >
            {{ $$t("create.done") }}
          </Button>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue";
import Dialog from "@/components/basic/dialog/Dialog.vue";
import SkyClippingFixedDuration from "@/components/media/clip/ClippingFixedDuration.vue";
import validationTools from "@/utils/validationTools.js";
import { storeToRefs } from "pinia";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);

import {
  ReferStyleLabelData,
  ReferEmotionalLabelData,
  getEnOptions,
} from "@/config/const.js";
const { $$language, $$t, $$tm, $$tValue } = getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  clipSourceData: {
    type: Object, // decode
    default: null,
  },
});

const emits = defineEmits(["update:visible", "complete"]);

const refClipFixedDuration = ref(null);

const renderData = reactive({
  visible: props.visible,
  clipSourceData: null,
  ifRender: true,
});

const onClose = () => {
  renderData.visible = false;
  refClipFixedDuration.value.pause();
  emits("update:visible", false);
  emits("cancel");
};

const onDoneClick = async () => {
  if (await refClipFixedDuration.value.validate()) {
    emits(
      "complete",
      {
        data: renderData,
        getClipedExportData: refClipFixedDuration.value.getClipedExportData,
      },
      () => {
        renderData.filename = "";
        renderData.moodTag = null;
        renderData.styleTag = null;
        refClipFixedDuration.value.pause();
        renderData.visible = false;
        emits("update:visible", false);
      }
    );
  } else {
    console.log("裁剪还未准备就绪");
  }
};

watch(
  () => props.visible,
  (val) => {
    renderData.visible = props.visible;
  }
);

watch(
  () => renderData.visible,
  (val) => {
    emits("update:visible", val);
    nextTick().then(() => {
      renderData.clipSourceData = props.clipSourceData;
    });
  }
);
watch(
  () => props.clipSourceData,
  (newValue, oldValue) => {
    nextTick().then(() => {
      renderData.clipSourceData = props.clipSourceData;
    });
  }
);

</script>
<style lang="scss">
.edit-origin_song-dialog {
  .dialog-box {
    padding: 40px 20px 40px 20px;
  }
  .dialog-header {
    padding: 0 20px;
  }
  .dialog-close {
    width: 36px;
    height: 36px;
    line-height: 36px;
    position: absolute;
    top: 30px;
    right: 30px;
  }
  .dialog-subtitle {
    padding: 0 20px;
  }
}
.edit-origin_song-dialog-mobile {
  .dialog-box {
    padding: 16px 16px 16px 16px;
  }
  .dialog-content {
    overflow-x: hidden;
  }
  .dialog-header {
    padding: 0 0px;
  }
  .dialog-subtitle {
    padding: 0 0px;
  }
  .dialog-close {
    width: 36px;
    height: 36px;
    line-height: 36px;
    position: absolute;
    top: 16px;
    right: 16px;
  }
}
.edit-origin_song {
  padding: 15px 0 0px 0;
  .edit-origin_song-item-label {
    padding: 0 20px;
    font-family: HarmonyOS Sans SC;
    font-size: 14px;
    font-weight: normal;
    line-height: 20px;
    height: 20px;
    color: #ffffff;
    margin-bottom: 8px;
    .edit-origin_song-item-error {
      color: #ff5f74;
    }
  }
  .edit-origin_song-item-edit-filename {
    height: 36px;
    min-height: 36px;
    border-radius: 8px;
    padding: 0 12px;
    margin: 0 20px 20px 20px;
    background: rgba(255, 255, 255, 0.1);
    align-items: center;
    input {
      height: 100%;
      width: 100%;
      font-family: HarmonyOS Sans SC;
      font-size: 14px;
      font-weight: normal;
      line-height: 20px;
      background: transparent;
      border: none;
      outline: none;

      color: #ffffff;
      &::placeholder {
        color: rgba(255, 255, 255, 0.5) !important;
      }
    }
    .edit-origin_song-item-edit-filename-count {
      font-size: 12px;
      font-weight: normal;
      line-height: 20px;
      color: rgba(255, 255, 255, 0.5);
    }
  }
  .edit-origin_song-item-tag {
    margin: 0 20px 18px 20px;
    .edit-origin_song-item-tag-item {
      font-family: HarmonyOS Sans SC;
      font-size: 12px;
      font-weight: 500;
      line-height: 28px;
      color: #ffffff;
      padding: 0 12px;
      margin: 0 4px 4px 0;
      border-radius: 24px;
      background: rgba(255, 255, 255, 0.1);
      text-transform: capitalize;
      &.active {
        background: #94adff;
        color: #000000;
        font-weight: 500;
      }
    }
  }
  .edit-origin_song-item-clip {
  }

  .edit-origin_song-item-items {
    margin: 20px 0 0px 0;
    padding: 0 20px;
    font-family: HarmonyOS Sans SC;
    font-weight: 400;
    font-size: 12px;
    text-align: center;
    color: rgba(255, 255, 255, 0.5);
    line-height: 16px;
    a {
      color: #fff;
    }
    a:hover {
      color: #94adff;
    }
  }
  .edit-origin_song-item-btn-box {
    margin: 30px 20px 0px 20px;
    .edit-origin_song-item-btn {
      width: 240px;
      margin: 0 auto;
    }
  }
  &.edit-origin_song-mobile {
    margin: 0 -20px 0 -20px;
    .edit-origin_song-item-items {
      text-align: left;
    }
    .edit-origin_song-item-btn-box {
      margin: 30px 20px 0px 20px;
      .edit-origin_song-item-btn {
        width: 100%;
        margin: 0 auto;
      }
    }
    .edit-origin_song-item-items {
      font-size: 11px;
    }
  }
}
</style>
